module.exports = __webpack_public_path__ + "img/screen-1.6c8290da.jpg";